import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CategoryDto } from '../dtos/category.dto';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MemoryService } from '../../../core/services/memory.service';
import { CategoryDataDto } from '../dtos/category-data.dto';
import { UpdateCategoryDto } from '../dtos/update-category.dto';
import { ReorderDto } from '../../../shared/dtos/reorder.dto';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  constructor(private http: HttpClient, private memoryService: MemoryService) {
  }

  getCategories(): Observable<CategoryDto[]> {
    return this.http.get<CategoryDto[]>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/categories`);
  }

  createCategory(categoryDataDto: CategoryDataDto): Observable<CategoryDto> {
    return this.http.post<CategoryDto>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/categories`, categoryDataDto);
  }

  updateCategory(updateCategoryDto: UpdateCategoryDto): Observable<CategoryDto> {
    return this.http.put<CategoryDto>(`${environment.cenplexBookingApiBaseUrl}/categories/${updateCategoryDto.categoryId}`, updateCategoryDto);
  }

  deleteCategory(categoryId: number): Observable<void> {
    return this.http.delete<void>(`${environment.cenplexBookingApiBaseUrl}/categories/${categoryId}`);
  }

  reorderCategories(reorderDto: ReorderDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/categories/${reorderDto.objectId}/reorder`, reorderDto);
  }
}
